// 加工指示区分の選択肢解決と表示ラベル生成をまとめる。
// 本文は HinbanMaster.js から移設したもの。

export function createKubunOptionService(deps) {
    const {
        DicVal,
        columninfo,
        isEmpty
    } = deps;

    function normalizeKakousijiKubunValue(rawValue) {
        const value = String(isEmpty(rawValue) ? "" : rawValue).trim();
        if (value === "") return "";
        const colonIndex = value.indexOf(":");
        const normalized = colonIndex !== -1 ? value.substring(0, colonIndex).trim() : value;
        if (normalized === "") return "";
        if (normalized === "量産") return "1";
        if (normalized === "追加") return "2";
        if (normalized === "サンプル") return "0";

        const matched = getKakousijiKubunOptions().find((item) => {
            const code = String(DicVal(item, "code", DicVal(item, "value", ""))).trim();
            const name = String(DicVal(item, "name", DicVal(item, "label", ""))).trim();
            return normalized === code || normalized === name;
        });
        if (!isEmpty(matched)) {
            const code = String(DicVal(matched, "code", DicVal(matched, "value", ""))).trim();
            if (code !== "") return code;
        }
        return normalized;
    }
    function isKakousijiSampleKubunValue(rawValue) {
        return normalizeKakousijiKubunValue(rawValue) === "0";
    }
    function parseKakousijiKubunOptionToken(token) {
        const text = String(token ?? "").trim();
        if (text === "") return null;
        const separator = text.indexOf(":") !== -1 ? ":" : (text.indexOf("：") !== -1 ? "：" : "");
        if (separator === "") return { value: text, label: text };
        const parts = text.split(separator);
        const value = String(DicVal(parts, 0, "")).trim();
        const label = String(parts.slice(1).join(separator)).trim();
        if (value === "" && label === "") return null;
        return { value: value === "" ? label : value, label: label === "" ? value : label };
    }
    function getKakousijiKubunOptions() {
        const col = (Array.isArray(columninfo) ? columninfo : []).find((item) =>
            String(DicVal(item, "columnid", "")).trim().toUpperCase() === "SSDX_KBN"
        );
        const raw = DicVal(col, "options", null);
        const parsed = [];
        const add = (code, name) => {
            const normalizedCode = String(code ?? "").trim();
            const normalizedName = String(name ?? "").trim();
            if (normalizedCode === "" && normalizedName === "") return;
            if (parsed.some((item) => item.code === normalizedCode)) return;
            parsed.push({
                code: normalizedCode,
                name: normalizedName === "" ? normalizedCode : normalizedName
            });
        };
        const parseAny = (value) => {
            if (isEmpty(value)) return;
            if (Array.isArray(value)) {
                value.forEach((item) => parseAny(item));
                return;
            }
            if (typeof value === "object") {
                const optionCode = String(DicVal(value, "code", DicVal(value, "value", DicVal(value, "id", "")))).trim();
                const optionName = String(DicVal(value, "name", DicVal(value, "label", DicVal(value, "text", optionCode)))).trim();
                add(optionCode, optionName);
                return;
            }
            String(value).split(/[\r\n,]+/).forEach((token) => {
                const parsedToken = parseKakousijiKubunOptionToken(token);
                if (isEmpty(parsedToken)) return;
                add(parsedToken.value, parsedToken.label);
            });
        };
        parseAny(raw);
        if (parsed.length !== 0) return parsed;
        return [
            { code: "1", name: "量産" },
            { code: "2", name: "追加" },
            { code: "0", name: "サンプル" }
        ];
    }
    function resolveKakousijiKubunLabel(value, index) {
        const normalizedValue = normalizeKakousijiKubunValue(value);
        if (normalizedValue !== "") {
            const matched = getKakousijiKubunOptions().find((item) =>
                normalizeKakousijiKubunValue(DicVal(item, "code", DicVal(item, "value", ""))) === normalizedValue
            );
            if (!isEmpty(matched)) {
                return String(DicVal(matched, "name", DicVal(matched, "label", normalizedValue))).trim();
            }
        }
        if (normalizedValue === "0") return "サンプル";
        if (normalizedValue === "1") return "量産";
        if (normalizedValue === "2") return "追加";
        if (normalizedValue !== "") return normalizedValue;
        return index === 0 ? "量産" : "追加";
    }
    function resolveKakousijiSummaryKubunLabel(item, index) {
        if (DicVal(item, "isDraft", false)) {
            const draftLabel = String(DicVal(item, "draftKubunLabel", DicVal(item, "kubunLabel", ""))).trim();
            if (draftLabel !== "") return draftLabel;
        }
        return resolveKakousijiKubunLabel(DicVal(item, "kubunValue", ""), index);
    }

    return {
        normalizeKakousijiKubunValue,
        isKakousijiSampleKubunValue,
        parseKakousijiKubunOptionToken,
        getKakousijiKubunOptions,
        resolveKakousijiKubunLabel,
        resolveKakousijiSummaryKubunLabel
    };
}
